var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#999999;}\n\t.st2{clip-path:url(#SVGID_00000165920671727342841740000002339699910656607925_);}\n\t.st3{clip-path:url(#SVGID_00000154414580393327991870000006068841012110793651_);}\n\t.st4{fill:none;stroke:#999999;stroke-width:2.2321;}\n\t.st5{clip-path:url(#SVGID_00000163032597201054764320000001705697019466655362_);}\n\t.st6{fill:#FF6CE2;}\n\t.st7{fill:#7B3566;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play_arrow_white_24dp",
    transform: "translate(-6096 7753.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    className: "st0",
    d: "M6096-7753.5h50v50h-50V-7753.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    className: "st1",
    d: "M6114.19-7744.21v31.41l20.45-15.71L6114.19-7744.21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons21);
export default __webpack_public_path__ + "static/media/Icons-21.656073ee51c8e1648661bf82dce1567d.svg";
export { ForwardRef as ReactComponent };